import { useEffect, useState } from 'react';
import { 
    Box, 
    Typography, 
    Button, 
    CircularProgress, 
    Container, 
    Paper
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../router/routes';
import { useQueryClient } from '@tanstack/react-query';

const PaymentSuccessPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const queryClient = useQueryClient();

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Here you might verify the session with your backend, or just trust the redirect.
        // For security, backend webhook is the source of truth.
        // Frontend just acknowledges. 
        // We'll wait a brief moment to allow webhook processing (optimistic) then refetch user.

        const timer = setTimeout(() => {
            queryClient.invalidateQueries({ queryKey: ['user-profile'] });
            setLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, [sessionId, queryClient]);


    const handleGoToDashboard = () => {
        navigate(ROUTES.DASHBOARD.path);
    };

    return (
        <Container maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', py: 8 }}>
            <Paper elevation={3} sx={{ p: 6, borderRadius: 4, width: '100%', textAlign: 'center' }}>
                <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
                    <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />
                </Box>
                
                <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                    Payment Successful!
                </Typography>
                
                <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
                    Thank you for your subscription. Your transaction has been completed successfully. 
                    {sessionId ? ` (Session ID: ${sessionId.substring(0, 8)}...)` : ''}
                </Typography>

                {loading ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <CircularProgress size={30} />
                        <Typography variant="caption" color="text.secondary">
                            Updating your account...
                        </Typography>
                    </Box>
                ) : (
                    <Button 
                        variant="contained" 
                        size="large" 
                        onClick={handleGoToDashboard}
                        fullWidth
                        sx={{ mt: 2, py: 1.5, fontSize: '1.1rem' }}
                    >
                        Go to Dashboard
                    </Button>
                )}
            </Paper>
        </Container>
    );
};

export default PaymentSuccessPage;
